import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import styles from './style.css';
import pencilImg from '../../images/icon_pencil.svg';
import Heading from '../Typography/Heading/Heading';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

export const showEstimatedBalance = accBalance => accBalance === 'PARTIAL';

const Accounts = ({ account }) => {
  return (
    <div id="account-details">
      <div className="inst-name left-column" id="fund-name">
        {account.accountName}
      </div>
      <div className="value">
        <div className="value-column">
          <div className="label left-column" id="account-number">
            Account number
          </div>
          <div className="left-column item-value" id="account-number-value">
            {account.accountNumber}
          </div>
        </div>
        <div className="value-column">
          <div className="label" id="transfer-balance">
            Transfer balance
          </div>
          <div className="item-value" id="transfer-balance-value">
            {account.liquidationOption}
          </div>
        </div>
        {showEstimatedBalance(account.liquidationOption) ? (
          <div className="value-column">
            <div className="label" id="allocation">
              Estimated transfer amount
            </div>
            <div className="item-value" id="allocation-value">
              ${account.estimatedTransferAmount}
            </div>
          </div>
        ) : (
          <div className="value-column"> </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

const AccDetails = ({ externalAccounts }) =>
  externalAccounts.map(account => {
    return (
      <div className="row" key={account.accountName}>
        <Accounts account={account} />
      </div>
    );
  });

const ManualInstitutionReview = ({ readOnly }) => {
  const { back, appState } = useContext(FlowContext);
  const { custodianName } = appState.store.app.custodian;
  const { externalAccounts } = appState.store.app;

  return (
    <div id="manual-institution-review">
      {!readOnly && <Heading text="Review your transfer selection(s)" />}
      <div className="my-funding">
        <div className="section-header">
          <div className="cell">
            <span>
              {' '}
              {custodianName !== '' ? custodianName : 'None Selected'}
            </span>
          </div>
          {!readOnly && (
            <div className="edit-cell">
              <MFBeaconButton
                data-name={generateGeneralTestID(
                  'ManaualInstitution',
                  'EditButton'
                )}
                type="button"
                onClick={back()}
                variant="tertiary"
                icon-align="left"
                label="Edit">
                <img
                  alt="Edit"
                  slot="icon"
                  src={pencilImg}
                  className="pencil"
                />
              </MFBeaconButton>
            </div>
          )}
        </div>
        <AccDetails externalAccounts={externalAccounts} />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default ManualInstitutionReview;
